// https://github.com/microsoft/TypeScript/issues/17002
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isArray(value: unknown): value is any[] | readonly any[] {
	return Array.isArray(value);
}
